// This function is required so Component base class methods and properties
// exist on the classes that extend from the base when running unit tests
// see https://stackoverflow.com/a/59394402
import Component from 'vue-class-component'

export default function AbstractComponent(v: any) {
  return Component(v)
}
